import { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import { papi } from "../portalApi";

const tone = (m) => (m == null ? "text-slate-400" : m < 0 ? "text-rose-600" : m < 15 ? "text-amber-600" : "text-emerald-700");

/* Top of the Dropship tab: average margin per client from its price list vs cost, best first. */
export const MarginSummary = ({ reloadKey, onPick }) => {
  const [d, setD] = useState(null);
  useEffect(() => { papi("get", "/dropship/margins").then(setD).catch(() => setD(false)); }, [reloadKey]);
  if (!d?.clients?.length) return null;
  return (
    <div className="mb-4 rounded-2xl border bg-white p-3" data-testid="ds-margin-summary">
      <p className="mb-2 flex items-center gap-1.5 text-sm font-bold text-slate-900"><TrendingUp className="h-4 w-4 text-teal-600" />Margin by client
        <span className="text-xs font-normal text-slate-500">· from each client's price list vs your cost</span></p>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {d.clients.map((c, i) => (
          <button key={c.id} onClick={() => onPick(c.id)} className="min-w-[150px] shrink-0 rounded-xl border p-2.5 text-left hover:border-teal-400" data-testid={`ds-margin-${c.id}`}>
            <div className="flex items-center gap-1"><span className="text-[10px] font-bold text-slate-400">#{i + 1}</span><b className="truncate text-sm">{c.name}</b></div>
            <p className={`text-xl font-black ${tone(c.avg_margin)}`} data-testid={`ds-margin-avg-${c.id}`}>{c.avg_margin == null ? "—" : `${c.avg_margin}%`}</p>
            <p className="text-[11px] text-slate-500">{c.matched} of {c.prices} priced product(s){c.matched ? ` · ${c.worst}% to ${c.best}%` : ""}</p>
            {c.below > 0 && <p className="text-[11px] font-semibold text-rose-600" data-testid={`ds-margin-below-${c.id}`}>{c.below} below cost</p>}
          </button>))}
      </div>
    </div>
  );
};
